<script setup>
import Homeheader from "@/components/Homeheader";
import { useMessage } from "@/hooks/useMessage";
import { ref, reactive, onMounted, computed, watch, onUnmounted } from "vue";
import { http, http2 } from "@/utils/http";
import { useStore } from "vuex";
import axios from "axios";
import { closeLoading } from "../../plugins/loadingFun.js";
import { useRouter } from "vue-router";
const router = useRouter();

const store = useStore();
// const centerDialogVisible = ref(true); // 普通解析
const vueInput = ref(true); //
const userNotice = ref(false); //
const centerDialogVisible = ref(false); // 普通解析
const centerDialogVisible1 = ref(false); // 二次解析
const parseInfo = reactive({
  downloadPath: "",
  url: "",
  down_item: [],
  down_type: "",
  file_type: "",
  parseFlag: false,
  vueInput: "",
});

const handPay = () => {
  router.push("/pay");
};

// =========

const countdown = ref(0); // 倒计时秒数
let timer = null; // 定时器

// 开始倒计时
const startCountdown = () => {
  countdown.value = 6;
  clearTimer();
  
  timer = setInterval(() => {
    countdown.value--;
    if (countdown.value <= 0) {
      clearTimer();
    }
  }, 1000);
}

// 清理定时器
const clearTimer = () => {
  if (timer) {
    clearInterval(timer);
    timer = null;
  }
}
onUnmounted(() => {
  clearTimer();
});

// =========

const noticeInfo = reactive({
  noticeTitle: "",
  noticeContent: "",
});

let textCopy = ref();
// 点击复制文本
const handCopy = () => {
  const text = parseInfo.downloadPath; // 复制文本内容
  const input = textCopy.value;
  input.value = text; // 修改input的内容
  input.select(); // 选中文本
  document.execCommand("copy"); // 浏览器复制
  useMessage(
    "success",
    "链接复制成功,请在浏览器新标签页地址栏粘贴复制的链接进行手动下载"
  );
};
// 一次解析
const handParse = async () => {
  vueInput.value = true;
  if (parseInfo.parseFlag) {
    useMessage("error", "解析间隔为10秒,请10秒钟以后再试!");
    return;
  }
  if (parseInfo.url == "") {
    useMessage("error", "请输入素材链接");
    return;
  }
  if (!(parseInfo.url.indexOf("http") != -1)) {
    useMessage("error", "请复制完整的链接");
    return;
  }
  // 发送请求
  try {
    const response = await http.post(
      "/v1/user/parse",
      {
        link: parseInfo.url,
      },
      { headers: { userToken: localStorage.getItem("userToken") } }
    );
    const res = response.data;
    // 解析失败
    if (res.code != 200) {
      useMessage("error", res.message);
      return;
    }
    if (res.data.down_type === "2") {
      // 需要二次解析
      centerDialogVisible1.value = true;
      parseInfo.down_item = res.data.down_item;
    } else {
      // 更新次数
      getAuthTwo();
      // 解析成功
      useMessage("success", res.message);
      // 设置10秒内不能重复解析
      parseInfo.parseFlag = true;
      setTimeout(function () {
        parseInfo.parseFlag = false;
      }, 10000); // 延迟时间以毫秒为单位
      parseInfo.downloadPath = res.data.down_url;
      parseInfo.file_type = res.data.file_type;
      centerDialogVisible.value = true;
      setTimeout(() => {getVueInput();}, 3000); 
      // store.state.userInfo.forEach((element) => {
      //   if (element.id == res.data.site) {
      //     element.download_num = res.data.sur;
      //   }
      // });
    }
  } catch (error) {
    closeLoading();
    useMessage("error", "请求超时,请重新尝试解析");
    // 在这里处理错误，例如显示一个友好的提示给用户
    console.error("发生错误:", error);
    // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
  }
};

// 二次解析
const handParse1 = async (file_type) => {
  if (parseInfo.parseFlag) {
    useMessage("error", "解析间隔为10秒,请10秒钟以后再试!");
    return;
  }
  // 发送请求
  http
    .post(
      "/v1/user/parseItem",
      {
        link: parseInfo.url,
        downType: file_type,
      },
      { headers: { userToken: localStorage.getItem("userToken") } }
    )
    .then((res) => {
      // 解析失败
      if (res.data.code != 200) {
        useMessage("error", res.data.message);
        return;
      }
      // 更新次数
      getAuthTwo();
      centerDialogVisible1.value = false;
      // 解析成功
      useMessage("success", res.data.message);
      // 设置10秒内不能重复解析
      parseInfo.parseFlag = true;
      setTimeout(function () {
        parseInfo.parseFlag = false;
      }, 10000); // 延迟时间以毫秒为单位
      parseInfo.downloadPath = res.data.data.down_url;
      parseInfo.file_type = res.data.data.file_type;
      centerDialogVisible.value = true;
      setTimeout(() => {getVueInput();}, 3000);
    })
    .catch((error) => {
      closeLoading();
      useMessage("error", "请求超时,请重新尝试解析");
      console.error("发生错误:", error);
      // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
    });
};

const handleUserNotice = () => {
    // 倒计时期间不允许点击
  if (countdown.value > 0) {
    return;
  }
  http
    .get("/v1/user/doUserNotice", {
      headers: {
        userToken: localStorage.getItem("userToken"),
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.code !== 200) {
        useMessage("error", res.message);
        return;
      }
      userNotice.value = false;
    })
    .catch((error) => {
      useMessage("error", "请求超时,请重新尝试解析");
      // 在这里处理错误，例如显示一个友好的提示给用户
      console.error("发生错误====:", error);
      // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
    });
};

const getAuth = () => {
  http
    .get("/v1/user/getAuth", {
      headers: {
        userToken: localStorage.getItem("userToken"),
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.code !== 200) {
        useMessage("error", res.message);
        return;
      }
      store.commit("addname", res.data.username);
      store.commit("addUserInfo", res.data.userInfo);
      store.commit("addNotice", res.data.notice);
      store.commit("addEmail", res.data.email);
      if (res.data.user_notice.state == 1) {
        userNotice.value = true;
        noticeInfo.noticeTitle = res.data.user_notice.name;
        noticeInfo.noticeContent = res.data.user_notice.desc;
          // 弹窗显示时开始倒计时
        startCountdown();
      }
    })
    .catch((error) => {
      useMessage("error", "请求超时,请重新尝试解析");
      // 在这里处理错误，例如显示一个友好的提示给用户
      console.error("发生错误====:", error);
      // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
    });
};

const getAuthTwo = () => {
  http
    .get("/v1/user/getAuth", {
      headers: {
        userToken: localStorage.getItem("userToken"),
      },
    })
    .then((response) => {
      const res = response.data;
      if (res.code !== 200) {
        useMessage("error", res.message);
        return;
      }
      store.commit("addname", res.data.username);
      store.commit("addUserInfo", res.data.userInfo);
      store.commit("addNotice", res.data.notice);
      store.commit("addEmail", res.data.email);
    })
    .catch((error) => {
      useMessage("error", "请求超时,请重新尝试解析");
      // 在这里处理错误，例如显示一个友好的提示给用户
      console.error("发生错误====:", error);
      // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
    });
};

// 点击获取input相关js
const handleGetInputJs = () => {

};

// 获取输入框js
const getVueInput = () => {
  http2
    .get("/v1/vue/vueCss", {
      headers: {
        userToken: localStorage.getItem("userToken"),
      },
    })
    .then((response) => {
    
    })
    .catch((error) => {
      useMessage("error", "请求超时,请重新尝试解析");
      // 在这里处理错误，例如显示一个友好的提示给用户
      console.error("发生错误====:", error);
      // 或者将错误状态存储到Vue组件中的数据中，并在页面上显示友好的提示
    });
};

onMounted(() => {
  // 更新次数
  getAuth();
});

// 动态创建下载标签
const handDownload = () => {
  const link = document.createElement("a"); //创建下载a标签
  link.href = parseInfo.downloadPath;
  link.style.display = "none"; //默认隐藏元素
  link.target = "_blank";
  document.body.appendChild(link); // body中添加元素
  link.click();
  document.body.removeChild(link); //下载完成后移除元素
};
</script>

// 素材解析 =================
<template>
  <el-col>
    <homeheader height-class="h-[280px]">
      <template #title> 素材解析 </template>
      <template #content>
        <div>
          <input
            v-model="parseInfo.url"
            placeholder="请输入素材链接"
            :class="
              $store.state.userInfo.length
                ? 'mt-1 pl-5 block w-full border-none bg-gray-100 h-10 rounded-xl shadow-lg hover:bg-blue-100 focus:outline-none  focus:bg-blue-100 focus:ring-0'
                : 'mt-1 pl-5 block w-full border-none bg-gray-100 h-10 rounded-xl shadow-lg focus:bg-blue-100 focus:outline-none focus:ring-0 cursor-not-allowed'
            "
            :disabled="$store.state.userInfo.length ? false : true"
            @click="handleGetInputJs"
          />
          <button
            :class="
              $store.state.userInfo.length
                ? 'mt-6 bg-blue-500 w-full py-2 rounded-xl text-white shadow-xl hover:shadow-inner focus:outline-none transition duration-500 ease-in-out transform hover:-translate-x hover:scale-102'
                : 'mt-6 bg-blue-500 w-full py-2 rounded-xl text-white shadow-xl cursor-not-allowed'
            "
            :disabled="$store.state.userInfo.length ? false : true"
            @click="handParse"
          >
            解析素材
          </button>
        </div>
        <input ref="textCopy" value="" style="opacity: 0; position: absolute" />
      </template>
      <!-- <template #subtitle> {{ animal.price }} </template>
      <template #badge> {{ animal.unit }} </template>
      <template #banner> {{ animal.category }} </template>
      <template #description> {{ animal.description }} </template> -->
    </homeheader>
  </el-col>

  <!-- 全员公告 -->
  <!-- <el-dialog
    :title="noticeInfo.noticeTitle"
    v-model="userNotice"
    width="24%"
    center
    top="20vh"
    :close-on-click-modal="false"
    :style="{ zIndex: 1000 }"
  >
    <div class="text-base text-gray-500" style="white-space: pre-line">
      <span>{{ noticeInfo.noticeContent }}</span>
    </div>
    <template #footer>
      <span class="dialog-footer" style="white-space: nowrap">
        <el-button
          type="primary"
          class="bg-blue-400 mb-2"
          @click="handleUserNotice"
        >
          点击按钮,今日不再提示
        </el-button>
      </span>
    </template>
  </el-dialog> -->

 <el-dialog
  :title="noticeInfo.noticeTitle"
  v-model="userNotice"
  width="24%"
  center
  top="20vh"
  :close-on-click-modal="false"
  :style="{ zIndex: 1000 }"
  :show-close="false"
>
  <div class="text-base text-gray-500" style="white-space: pre-line">
    <span>{{ noticeInfo.noticeContent }}</span>
  </div>
  <template #footer>
    <span class="dialog-footer" style="white-space: nowrap">
            <el-button
        type="primary"
        class="btn-danger mb-2 pr-8 pl-8"
           @click="handPay"
        v-if="noticeInfo.noticeTitle==='套餐停止通知'"
      >
         点击购买套餐 
      </el-button>
      <el-button
        type="primary"
        class="bg-blue-400 mb-2"
        @click="handleUserNotice"
        :disabled="countdown > 0"
      >
        {{ countdown > 0 ? `请等待 ${countdown} 秒后关闭` : '点击按钮,今日不再提示' }}
      </el-button>
    </span>
  </template>
</el-dialog>


  <!-- 二次解析 -->
  <el-dialog
    v-model="centerDialogVisible1"
    title="选择下载类型"
    width="20%"
    align-center
    style="margin-top: 300px"
  >
    <div class="mb-0">
      <span
        >点击下面按钮
        <span class="text-xl text-red-500">选择需要的下载格式</span>
        进行下载
      </span>
    </div>

    <!-- <div class="mb-6">
      <span
        >如果点击下载按钮
        <span class="text-xl text-red-500">下载失败(或者出现403)</span>
        按照下面方法操作:
      </span>
    </div>
    <span class="text-xl"
      >点击复制链接按钮,打开<span class="text-red-500">(新的标签页)</span
      >粘贴到地址栏进行下载
    </span>

    <div class="mt-6">
      <span>（一定要打开浏览器新的标签页） </span>
    </div> -->
    <template #footer>
      <span class="dialog-footer" style="white-space: nowrap">
            <el-button
          v-for="data in parseInfo.down_item"
          :key="data.file_type"
          type="primary"
          class="bg-blue-400 mb-4 mr-4"
          @click="handParse1(data.file_type)"
        >
          {{ data.name }}
        </el-button>
      </span>
    </template>

    
  </el-dialog>

  <!-- 一次解析 -->
  <el-dialog
    v-model="centerDialogVisible"
    title="解析成功"
    width="23%"
    align-center
  >
    <div class="mb-6 text-xl text-red-500">
      <span>《 解析成功 》 请点击《 立即下载 》按钮进行下载 </span>
    </div>
    <div class="mb-6">
      <span
        ><span class="text-blue-500">如果点击</span
        >下载按钮下载失败(或者出现403)
        <!-- <span class="text-xl text-red-500">下载失败(或者出现403)</span> -->
        按照下面方法操作:
      </span>
    </div>
    <!-- <span class="text-xl"
      >点击复制链接按钮,打开<span class="text-red-500">(新的标签页)</span
      >粘贴到地址栏进行下载
    </span> -->
    <span>点击复制链接按钮,打开(新的标签页)粘贴到地址栏进行下载 </span>
    <!-- <div class="mt-6">
      <span>（一定要打开浏览器新的标签页） </span>
    </div> -->
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="handCopy">复制下载链接手动下载</el-button>
        <!-- <el-button type="primary" class="bg-blue-400" @click="handDownload">
          点击下载
        </el-button> -->

        <!-- 带请求来源 -->
        <a
          v-if="parseInfo.file_type === '5'"
          class="btn btn-danger"
          :href="parseInfo.downloadPath"
          target="_blank"
          rel="noopener nofollow"
          >立即下载</a
        >
        <!-- 不带请求来源 -->
        <a
          v-else
          class="btn btn-danger"
          :href="parseInfo.downloadPath"
          target="_blank"
          rel="noreferrer noopener nofollow"
          >立即下载</a
        >
      </span>
    </template>
  </el-dialog>
</template>

<style lang="scss" scoped>

.el-button.is-disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

  .responsive-button {
    /* 设置按钮的宽度为自适应 */
    flex: 1 1 auto;
    max-width: 150px; /* 按钮的最大宽度 */
    min-width: 80px; /* 按钮的最小宽度 */
    white-space: nowrap; /* 防止文字换行 */
    text-align: center; /* 文字居中 */
  }

  .dialog-footer {
    /* 给父容器定义响应式布局 */
    display: flex;
    flex-wrap: wrap; /* 换行 */
    justify-content: center; /* 按钮居中对齐 */
    align-items: center; /* 垂直居中对齐 */
  }

.el-col {
  margin: 8px 0;
}

.dialog-footer button:first-child {
  margin-right: 10px;
}
.btn-danger {
  color: #fff !important;
  background-color: #dc3545 !important;
  border-color: #dc3545 !important;
}
.btn-danger:hover {
  background-color: #c82333 !important; /* 鼠标悬停时的背景色 */
  border-color: #bd2130 !important; /* 鼠标悬停时的边框颜色 */
}
.btn {
  display: inline-block;
  font-weight: 400;
  color: #212529;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0.25rem;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
</style>
